import {Injectable} from "@angular/core";
import {Actions, createEffect, CreateEffectMetadata, ofType} from '@ngrx/effects';
import * as dataSourcesMetrics from "./dataSourcesMetrics.actions";
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {DataSourceMetric} from '../../interfaces/metrics';
import {MetricsService} from '../../services/metrics.service';
import {Site} from '../../interfaces/site';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';

@Injectable()
export class DataSourcesMetricsEffects {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);

  public load$: Observable<TypedAction<string> & { metrics: Serializers<DataSourceMetric> }> & CreateEffectMetadata = createEffect((): Observable<TypedAction<string> & { metrics: Serializers<DataSourceMetric> }> => this._actions$
    .pipe(
      ofType(dataSourcesMetrics.loadDataSourcesMetrics),
      withLatestFrom(this._dataset$),
      switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<SerializerResponse<Serializers<DataSourceMetric>>> => this._metricsService.getDataSourceMetrics(dataset)),
      map((results: SerializerResponse<Serializers<DataSourceMetric>>) => dataSourcesMetrics.loadDataSourcesMetricsSuccess({
        metrics: results.data
      }))
    )
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _metricsService: MetricsService,
    private readonly _store: Store<AppState>
  ) {}
}
